__turbopack_context__.v({
  "cell": "StatusCell-module__v8XJEW__cell",
  "root": "StatusCell-module__v8XJEW__root",
  "statusLabel": "StatusCell-module__v8XJEW__statusLabel",
});
